import axios from 'axios';

// API 基础 URL，开发环境使用相对路径，生产环境可配置
const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动添加 token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：统一处理错误
client.interceptors.response.use(
  (response) => response,
  (error) => {
    // 只有携带现有会话的请求失败时才退出；登录失败应留在页面显示错误。
    const hadAuthorization = Boolean(error.config?.headers?.Authorization);
    if (hadAuthorization && (error.response?.status === 401 || error.response?.status === 403)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;
